import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';

import { VamRoutingModule } from './vam-routing.module';

import { AngularDualListBoxModule } from 'angular-dual-listbox';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { ModalModule } from 'ngx-bootstrap/modal';

import { GalleryModule } from 'ng-gallery';
import { LightboxModule } from 'ng-gallery/lightbox';

import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { NgxMaskModule } from 'ngx-mask';
import { CommonCompModule } from 'src/app/common/common-comp.module';
import { SidebarState } from 'src/app/state/sidebar.state';
import { ComponentsModule } from '../../components/components.module';
import { CarHistoryReportComponent } from './car-history-report/car-history-report.component';
import { EstimatesComponent } from './estimates/estimates.component';
import { FlagsComponent } from './flags/flags.component';
import { GalleryComponent } from './gallery/gallery.component';
import { InformationComponent } from './information/information.component';
import { OfflineDataComponent } from './offline-data/offline-data.component';
import { OptionsComponent } from './options/options.component';
import { VamComponent } from './vam.component';

@NgModule({
  declarations: [
    VamComponent,
    InformationComponent,
    FlagsComponent,
    EstimatesComponent,
    GalleryComponent,
    OptionsComponent,
    CarHistoryReportComponent,
    OfflineDataComponent
  ],
  imports: [
    NgxSliderModule,
    CommonModule,
    ComponentsModule,
    VamRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    AngularDualListBoxModule,
    CommonCompModule,
    GalleryModule,
    LightboxModule,
    ModalModule.forRoot(),
    BsDatepickerModule.forRoot(),
    AccordionModule.forRoot(),
    PopoverModule.forRoot(),
    NgxMaskModule.forRoot(),
    NgMultiSelectDropDownModule.forRoot(),
    TranslateModule.forChild({
      extend: true
    })
  ],
  providers: [SidebarState],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class VamModule {}
